import { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { useAuth0 } from '@auth0/auth0-react';
import AppStore from '../../store/AppStore';
import { RouterStore } from '../../store';
import { getAuth0LoginWithRedirectOptions, getPostAuthPath, getPostLoginReturnTarget } from '../../router/postLogin.utils';

interface ILoginProps {
    app: AppStore;
    routing: RouterStore;
}

const LoginPage = inject(
    'app',
    'routing',
)(
    observer(function LoginPage({ app, routing }: ILoginProps) {
        const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

        useEffect(() => {
            if (isLoading) {
                return;
            }

            if (!isAuthenticated) {
                const { redirectUri, appState } = getAuth0LoginWithRedirectOptions();
                void loginWithRedirect({
                    appState,
                    authorizationParams: { redirect_uri: redirectUri },
                });
                return;
            }

            const handleAuthenticated = async () => {
                try {
                    const token = await app.refreshAuthorization();

                    if (!token) {
                        await app.logout();
                        return;
                    }

                    const returnPath = getPostLoginReturnTarget();
                    if (returnPath) {
                        routing.replace(returnPath);
                        return;
                    }

                    const path = getPostAuthPath(token);
                    routing.push(path);
                } catch (error) {
                    console.error('Auth0 token validation failed', error);
                    await app.logout();
                }
            };

            void handleAuthenticated();
        }, [isLoading, isAuthenticated]);

        return <div>Loading...</div>;
    }),
);

export default LoginPage;
